import React, { useState } from 'react';
import { IntercomCtrl } from '../../@vendor/Intercom';
import { Host } from '../../Host';
import { Icon } from '../../concepts/resources/Icon';
import { HeaderButton } from '../../ui/HeaderButton';
import { Tip } from '../../ui/Tip';
import { useResolve } from '../Container';
import { Popover } from '../canvas/ui/Popover';
import { optionsPopupWith } from '../popups/OptionsPopup';
import { PopupManager } from '../popups/PopupManager';
import { Menu } from './../../ui';
import { FeedbackPopup } from './FeedbackPopup';

const doFeedbackPopupSequence = async (popups: PopupManager) => {
    const { actioned, data } = await popups.invoke({ ui: FeedbackPopup });
    if (actioned && data) {
        await popups.invoke(optionsPopupWith(
            'Thank you!',
            'We appreciate your help making Metro Retro better!',
            [[true, 'Close', 'common', 'confirm']]
        ));
    }
};

export const HelpMenu = ({ onClose }: { onClose: () => void }) => {
    const popups = useResolve(PopupManager);

    const closeAnd = (fn: () => void) => () => { onClose(); fn(); };
    const onOpenFeedback = closeAnd(() => doFeedbackPopupSequence(popups));
    const onOpenIntercom = closeAnd(() => IntercomCtrl.show);

    return (
        <Menu>
            <Menu.Section first title="Docs &amp; Help">
                <a data-action="header.help.openDocs" rel="noreferrer" target="_blank" href="https://docs.metroretro.io">
                    <Menu.Item onClick={onClose}>
                        <Menu.ItemText>
                            User Manual
                        </Menu.ItemText>
                    </Menu.Item>
                </a>
                {IntercomCtrl.enabled && <Menu.Item data-action="header.help.openIntercom" onClick={() => onOpenIntercom()}>
                    <Menu.ItemText>
                        Support Chat
                    </Menu.ItemText>
                </Menu.Item>}
                <Menu.Item data-action="header.help.openFeedback" onClick={() => onOpenFeedback()}>
                    <Menu.ItemText>
                        Bug Report / Feedback
                    </Menu.ItemText>
                </Menu.Item>
            </Menu.Section>
            <Menu.Section title="Account">
                <a data-action="header.help.logout" href={`${Host.baseUrl}/logout?redirect=/`}>
                    <Menu.Item>
                        <Menu.ItemText>
                            Sign Out
                        </Menu.ItemText>
                    </Menu.Item>
                </a>
            </Menu.Section>
        </Menu>
    );
};

export const HelpButton = () => {

    const [open, setOpen] = useState(false);

    return <Popover
        placement="bottom-end"
        content={<HelpMenu onClose={() => setOpen(false)} />}
        inner={{ direction: 'down' }}
        open={open}
        onOpenChange={setOpen}
    >
        <Tip text="Everything Else" position="bottom" disabled={open}>
            <HeaderButton data-action="header.openHelp" active={open}>
                <Icon size="1.5" src="deqo://icons/hero/menu" />
            </HeaderButton>
        </Tip>
    </Popover>;
};

